import axios from 'axios';
import { ROOT_API_URL } from '../../../api-config';
import { loader, toastr } from '../CommonActions';
import { auth } from '../../../services/auth.service';

export const GET_POSITION_GROUPS = 'GET_POSITION_GROUPS';
export const ADD_POSITION_GROUP = 'ADD_POSITION_GROUP';
export const GET_GROUP_TYPES = 'GET_GROUP_TYPES';
export const DELETE_POSITION_GROUP = 'DELETE_POSITION_GROUP';
export const UPDATE_POSITION_GROUP = 'UPDATE_POSITION_GROUP';

const successColor = 'success';
const errorColor = 'danger';
const warningColor = 'warning';

export function fetchPositionGroups() {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.get(`${ROOT_API_URL}/ManagePositionGroup/GetPositionGroups`, { headers: auth.authHeader() })
			.then((response) => {
				console.log('see here........', response);
				dispatch({
					//type: GET_POSITION_GROUPS,
					payload: response.data
				});
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function getGroupTypes() {
	return function(dispatch) {
		axios
			.get(`${ROOT_API_URL}/ManagePositiongroup/GetPositionGroupTypes`, { headers: auth.authHeader() })
			.then((response) => {
				//console.log('check here------', response);
				dispatch({
					type: GET_GROUP_TYPES,
					payload: response.data
				});
			})
			.catch((response) => {
				console.log(response);
			});
	};
}

export function addPositionGroup(model) {
	// console.log('to see action creator received: ', model);
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManagePositiongroup/CreatePositionGroup`, model, { headers: auth.authHeader() })
			.then(function(response) {
				// console.log(response);
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: ADD_POSITION_GROUP,
						payload: response.data.positionGroups
					});
					var success =
						response && response.data ? response.data.message : 'Position Group Created Successfully';
					dispatch(toastr(true, success, successColor));
				} else {
					var err = response && response.data ? response.data.message : '';
					dispatch(toastr(true, err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(loader(false));
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function deletePositionGroup(model) {
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManagePositionGroup/deletePositionGroup`, model, { headers: auth.authHeader() })
			.then((response) => {
				console.log(response);
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: DELETE_POSITION_GROUP,
						payload: response.data.positionGroups
					});
					var success =
						response && response.data ? response.data.message : 'Position Group Deleted Successfully';
					dispatch(toastr(true, success, successColor));
				} else {
					var err = response && response.data ? response.data.message : 'Error Occured';
					dispatch(toastr(true, err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(toastr(true, err, errorColor));
			});
	};
}

export function updatePositionGroup(model) {
	console.log('action creator to see what you recived: ', model);
	return function(dispatch) {
		dispatch(loader(true));
		axios
			.post(`${ROOT_API_URL}/ManagePositionGroup/UpdatePositionGroup`, model, { headers: auth.authHeader() })
			.then((response) => {
				console.log('update response', response);
				if (response && response.data && response.data.issuccess) {
					dispatch({
						type: UPDATE_POSITION_GROUP,
						payload: response.data.positionGroups
					});
					var success =
						response && response.data ? response.data.message : 'Position Group Updated Successfully';
					dispatch(toastr(true, success, successColor));
				} else {
					var err = response && response.data ? response.data.message : 'Error Occured';
					dispatch(toastr(true, err, warningColor));
				}
				dispatch(loader(false));
			})
			.catch((response) => {
				dispatch(loader(false));

				var err = response && response.data ? response.data.message : 'Network Connection Error';
				dispatch(toastr(true, err, errorColor));
			});
	};
}
